import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import ApplicationLinkIdField from "../../applications/ApplicationLinkIdField";
import CustomerIdLinkIdField from "../../customers/CustomerIdLinkIdField";
import LoanNumLinkIdField from "../../loans/LoanNumLinkIdField";
import CustomTableSmall from "../../unit/CustomTableSmall";
const CustomAttentionField = ({ ...props }) => {
  const record = props.record;
  if (record == null) {
    return null;
  }
  const transferFailedNumber = record.iTransferFailedNumber;
  const insufficientBalanceCheckNumber = record.iInsufficientBalanceCheckNumber;
  const transferFatalErrorNumber = record.iTransferFatalErrorNumber;
  let textcolor = "textSecondary";

  let errorValue = [];
  if (transferFailedNumber >= 2) {
    errorValue.push("Transfer Failed");
  }
  if (insufficientBalanceCheckNumber >= 2) {
    errorValue.push("Insufficient Balance");
  }
  if (transferFatalErrorNumber >= 1) {
    errorValue.push("Funding Source Removed");
  }
  return (
    <Typography variant="body2" sx={{ mb: 1, color: "black" }}>
      {errorValue.map((item, index) => (
        <span key={index}>
          {item}
          {index !== errorValue.length - 1 ? <br /> : ""}
        </span>
      ))}
    </Typography>
  );
};
const DashboardSearchLoan = ({ ...props }) => {
  const searchResult = Array.isArray(props.searchResult)
    ? props.searchResult
    : [];
  return (
    <TableContainer sx={{ maxHeight: 440 }}>
      <CustomTableSmall
        stickyHeader
        aria-label="sticky table"
        id="table-dashboard-search-loans"
        key={"dashboardSearchLoan"}
      >
        <TableHead>
          <TableRow>
            <TableCell align="center" className="hm-table-header">
              App #
            </TableCell>
            <TableCell align="center" className="hm-table-header">
              Loan #
            </TableCell>
            <TableCell align="center" className="hm-table-header">
              User #
            </TableCell>
            <TableCell className="hm-table-header">Product Name</TableCell>
            <TableCell className="hm-table-header">Borrower</TableCell>
            <TableCell className="hm-table-header">Co-Borrower</TableCell>
            <TableCell className="hm-table-header">Guarantor</TableCell>
            <TableCell className="hm-table-header">Referral</TableCell>
            <TableCell className="hm-table-header">Loan Status</TableCell>
            <TableCell className="hm-table-header">Attention</TableCell>
            {/* <TableCell>Note Date</TableCell>
            <TableCell>Note Amount</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {searchResult == undefined ||
          searchResult.length == 0 ||
          searchResult == null ? (
            <TableRow>
              <TableCell colSpan={8}>No Data </TableCell>
            </TableRow>
          ) : (
            searchResult.map((row: any, index: number) => (
              // Loans: App# [linked to the Individual Application], Loan # [linked to the Individual Loan], Product, Borrower [linked to the Individual Customer], Co-Borrower, Guarantor, Loan Status [linked to the Application List]
              <TableRow key={index}>
                <TableCell align="center">
                  {row?.sStatus == "Incomplete" ? (
                    <>{row?.id}</>
                  ) : (
                    <ApplicationLinkIdField
                      id={row?.id}
                      loannum={row?.sLoanNum}
                    />
                  )}
                </TableCell>
                <TableCell align="center">
                  {row?.sStatus == "Funded" ? (
                    <LoanNumLinkIdField id={row?.id} loannum={row?.sLoanNum} />
                  ) : (
                    <>{row?.sLoanNum}</>
                  )}
                </TableCell>
                <TableCell align="center">
                  <CustomerIdLinkIdField
                    id={row?.iUserId}
                    name={row?.iUserId}
                  />
                </TableCell>
                <TableCell>{row?.sProductName}</TableCell>
                <TableCell>
                  {row?.sFirstName} {row?.sLastName}
                </TableCell>
                <TableCell>
                  {row?.coFname} {row?.coLname}
                </TableCell>
                <TableCell>
                  {row?.guarantorFname} {row?.guarantorLname}
                </TableCell>
                <TableCell>{row?.referral}</TableCell>
                <TableCell>{row?.curStatus}</TableCell>
                <TableCell>
                  <CustomAttentionField record={row} />
                </TableCell>
                {/* <TableCell>{formatDate(row?.dNoteDate)}</TableCell>
                <TableCell>{formatCurrency(row?.iLoanAmount)}</TableCell> */}
              </TableRow>
            ))
          )}
        </TableBody>
      </CustomTableSmall>
    </TableContainer>
  );
};
export default DashboardSearchLoan;
